<template>
  <form action="show-emrgoal-result" method="post" id="showEmrResult">
  	<input type="hidden" v-model="_token" name="_token">
    <p class="hf_heading06 hf_light">Tell us how much you spend monthly</p>
    <div class="form-group dynamic-input">
      <label>I and my family spend<span class="inr-symbol hf_dark">&#8377;</span></label>
      <input type="text" id="amountEmrReqd" name="amountEmrReqd" v-model="amountEmrReqd" class="restDot numbersonly" :class="amountEmrReqdMClass" @keyup="resetEmrCalculation()" placeholder="50,000" min="0" maxlength="13" required>
      <span class="plane-text">per month.</span>
    </div>
    <VueRecaptcha 
      sitekey="6Ldr460jAAAAAO6wyw1mVTSg_2T2Zp9WTkO9SL_9" 
      ref="recaptcha"
      size="invisible"
      :load-recaptcha-script="true" 
      @verify="recaptchaVerified" 
      @expired="resetCaptcha">
    </VueRecaptcha>
    <div class="greenbgnotification-message">
      <p v-show="showEmrError" class="errorMessage inflation-text hf_bodytext02">
        <span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
        {{ showEmrErrorText }}
      </p>
    </div>
    <div class="button-container">
      <button type="button" class="btn-primaryNoIcon lg-primarynoIcon" @click.stop="showEmrResult()">Know more</button>
    </div>
  </form>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';
export default {
  components: {
    VueRecaptcha
  },
  created() {},
  data() {
    return {
    	_token : this.$token,
      amountEmrReqdMClass: '',
      mandatoryClassName: 'redunderline',
    	showEmrErrorText: '',
    	showEmrError: false,
      recaptchaToken:'',
      amountEmrReqd:'',
    };
  },
  props: {},
  watch: {
  amountEmrReqd(){
		var res =  this.formatAmount(this.amountEmrReqd)
		this.amountEmrReqd = res;
    },
  },
  mounted(){
  },
  methods: {
    resetCaptcha() {
      // console.log("resetCaptcha");
      this.$refs.recaptcha.reset();
      this.recaptchaToken = "";
    },
    recaptchaVerified(token) {
      // console.log("recaptchaVerified");
      if (token ) this.recaptchaToken = token;
      // console.log("recaptchaToken="+ this.recaptchaToken);
      document.getElementById("showEmrResult").submit();
    },
  	showEmrResult(){
  		// console.log("Click event triggered");
  		// console.log(this.amountEmrReqd);

  		//Check for validation and collect data for calculations
  		//======================================================
  		let amountEmrReqd = this.amountEmrReqd;
      console.log("amountEmrReqd="+amountEmrReqd);

  		if(amountEmrReqd == "" || amountEmrReqd == undefined){
  			this.showEmrErrorText = "Please enter mandatory data first";
  			this.showEmrError = true;
        this.amountEmrReqdMClass = this.mandatoryClassName;
  		}else{
        //remove all redunderline class for mandatory
        //============================================
        this.amountEmrReqdMClass = "";

  			//Check all the basic validations eg.age, amt
				//=============================================
        console.log("_token="+this.$token);
				axios.post('/chkEmrGoalValidations',{amountReqd: amountEmrReqd, calcReq: 0, _token: this.$token})
        .then((responseEmr)=>{
        	// console.log(responseEmr);
        	let resEmrData = responseEmr.data;
        	if(resEmrData.status == true){
						this.showEmrErrorText = "";
			    	this.showEmrError = false;
        		// Show result on next page
					  //==================================================
						// this.$nextTick is added because above form is submitted before values changed in form
						//--------------------------------------------------------
				  	// this.$nextTick(() => {

                // Trigger clevertap event
                //===================================================
                // clevertap.event.push("Emergency Calculator", {
                //   "page name": window.location.pathname,
                //   "Monthly Spend": amountEmrReqd,
                // });

                //execute captcha call here
                //=========================================
                this.$refs.recaptcha.execute();
			    	// 	});
        	}else{
            if(resEmrData.error == undefined){
              this.showEmrErrorText = "Page session expired, Please refresh the page";
              this.showEmrError = true;
            }else{
              this.showEmrErrorText = resEmrData.error;
              this.showEmrError = true;
            }
            //Reset captcha called
            //=====================================
            this.resetCaptcha();
        	}
        }).catch(responseEmr => {
		        console.log(responseEmr.data);
		    })
  		}
  	},
  	resetEmrCalculation(){
      // On keyup of field show button for calculation and hide result 
			//================================================================
			this.showEmrErrorText = "";
    	this.showEmrError = false;
    }
  },
};
</script>

<style lang="scss" scoped></style>
